
//  index.js
//  Tulip Web Modules SDK
//
//  Export file for detector directory
//  © 2017 Tulip.
//


// - External Dependencies

/// Uses the Browser-Based Language-Detector Internationalization Extensions plugin.
/// https://github.com/i18next/i18next-browser-languageDetector#introduction
import RootDetector from 'i18next-browser-languagedetector';

// - Internal Dependencies

/// The Tulip Web-to-Native Bridge Language Detector from this directory.
import nativeBridgeDetector from './nativeBridge';

// - Exports

/// The shared, default Language Detector.
const detector = new RootDetector();
// …with custom, Tulip-specific detection behaviour.
detector.addDetector(nativeBridgeDetector);

export default detector;



// WEBPACK FOOTER //
// ./src/i18n/detector/index.js